"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReportMetaFiltersRootOperator = /** @class */ (function () {
    function ReportMetaFiltersRootOperator(type, operator, children) {
        this.type = type || 'operator';
        this.operator = operator || 'and';
        this.children = children || null;
    }
    return ReportMetaFiltersRootOperator;
}());
exports.ReportMetaFiltersRootOperator = ReportMetaFiltersRootOperator;
//# sourceMappingURL=report-meta-filters-root-operator.model.js.map